module.exports = __webpack_public_path__ + "static/media/111.75af02e1.png";